import useSWR from 'swr'
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded'
import GoogleIcon from '@mui/icons-material/Google'
import InstagramIcon from '@mui/icons-material/Instagram'
import RedditIcon from '@mui/icons-material/Reddit'
import { useEffect, useState } from 'react'
import axiosInstance from '../../../utils/axiosInstance'
import './styles.scss'

interface Socials {
  instagram: number
  facebook: number
}

interface MetaLead {
  id: string
  platform: string
  campaignName: string
}

interface SocialStatsResponse {
  metaLeads: MetaLead[]
}
const SocialStats = () => {
  const [socials, setSocials] = useState<Socials>({ instagram: 0, facebook: 0 })
  const { data } = useSWR<SocialStatsResponse>('/social-stats', axiosInstance)

  const percentage = (value1: number, value2: number) => {
    return Math.round((100 * value1) / value2)
  }

  useEffect(() => {
    const instagram =
      data?.metaLeads?.filter((item: MetaLead) => item.platform === 'ig').length || 0
    // Audience Network ('an') and Messenger ('msg') are Meta/Facebook surfaces -> count as Facebook
    const facebook =
      data?.metaLeads?.filter((item: MetaLead) => ['fb', 'an', 'msg'].includes(item.platform))
        .length || 0
    const total = data?.metaLeads?.length || 0

    if (total > 0) {
      setSocials({
        instagram: percentage(instagram, total),
        facebook: percentage(facebook, total),
      })
    }
  }, [data])

  return (
    <div className="socialsStatsWrapper">
      <div className="social">
        <FacebookRoundedIcon className="icon" />
        <div className="stats">
          <span>{socials.facebook || 0} %</span>
          <p>Facebook</p>
        </div>
      </div>
      <div className="social">
        <GoogleIcon className="icon" />
        <div className="stats">
          <span>0 %</span>
          <p>Google</p>
        </div>
      </div>
      <div className="social">
        <InstagramIcon className="icon" />
        <div className="stats">
          <span>{socials.instagram || 0} %</span>
          <p>Instagram</p>
        </div>
      </div>
      <div className="social">
        <img src="/socials/spotify.svg" className="icon" />
        <div className="stats">
          {/* <span>0 %</span> */}
          <p>Spotify</p>
        </div>
      </div>
      <div className="social">
        <img src="/socials/tiktok-monochrome.svg" className="icon" />
        <div className="stats">
          <span>0 %</span>
          <p>TikTok</p>
        </div>
      </div>
      <div className="social">
        <RedditIcon className="icon" />
        <div className="stats">
          <span>0 %</span>
          <p>Reddit</p>
        </div>
      </div>
    </div>
  )
}

export default SocialStats
